export default {
    data() {
        return {
            ctrlKey: false,
        }
    },
    created() {
        window.addEventListener('keydown', this.OnKeyEvent)
        window.addEventListener('keyup', this.OnKeyEvent)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.OnKeyEvent)
        window.removeEventListener('keyup', this.OnKeyEvent)
    },
    methods: {
        OnKeyEvent(event) { this.ctrlKey = event.ctrlKey; },
        CtrlOpen(path) {
            if (this.ctrlKey) this.OpenTab(path);
            else this.$router.push({ path: path }).catch(() => { });
        },
        OpenTab(path) {
            let routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        }
    },
};